const splitProductTitle = (title) => {
  if (title.dataset.titleSplit === "true") {
    return;
  }

  const text = title.textContent;
  const separator = text.match(/\s+-\s+/);

  if (!separator) {
    return;
  }

  const separatorIndex = separator.index;
  const firstLine = text.slice(0, separatorIndex).trimEnd();
  const secondLine = text.slice(separatorIndex + separator[0].length).trimStart();
  const secondLineElement = document.createElement("span");

  secondLineElement.className = "product-title__second-line";
  secondLineElement.textContent = secondLine;

  title.replaceChildren(firstLine, document.createElement("br"), secondLineElement);
  title.dataset.titleSplit = "true";
};

const splitProductTitles = (root = document) => {
  if (root instanceof Element && root.matches(".product-title")) {
    splitProductTitle(root);
  }

  root.querySelectorAll?.(".product-title").forEach(splitProductTitle);
};

splitProductTitles();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        splitProductTitles(node);
      }
    });
  });
}).observe(document.body, { childList: true, subtree: true });
